<template>
    <div class="Statistics" >
        <Title firstName="暖通系统设备启停统计" lastName="EQUIPMENT START AND STOP"/>
        <div class="echarts">
           <div class="floor">
               <div class="item">
                   <div class="title">公共空调</div>
                   <div class="progress">
                       <div class="num">--<span>/--</span></div>
                       <div class="state">启动/停止</div>
                   </div>
                   <div class="error">故障：0</div>
               </div>
               <div class="item">
                   <div class="title">新风机</div>
                   <div class="progress">
                       <div class="num">--<span>/--</span></div>
                       <div class="state">启动/停止</div>
                   </div>
                   <div class="error">故障：0</div>
               </div>
               <div class="item">
                   <div class="title">送排风机</div>
                   <div class="progress">
                       <div class="num">--<span>/--</span></div>
                       <div class="state">启动/停止</div>
                   </div>
                   <div class="error">故障：0</div>
               </div>
           </div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
const Title = () => import('../../../../components/title/Title')
const Graph = () => import('../../../../components/echarts/graph.vue')
const charts = () => import('../../../../components/echarts/charts.vue')
export default {
    data(){
        return {
            list:[
                {
                    name:""
                }
            ]
        }
    },
    components:{
        Title,Graph,charts
    },
    mounted(){
        
    },
    methods:{
       
    },
    watch:{
        
    },
    computed:{
        
    }
}
</script>

<style lang="less" scoped>
    .Statistics{
        // height: 33.3vh;
        width: 20vw;
        // height: 493rem;
        position: fixed;
        top: 70.5vh;
        left: 2vw;
        z-index: 1;

        .echarts{
            position: relative;
            height: 22.5vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);
            overflow: hidden;
            .floor{
                padding:0 30rem;
                display: flex;
                align-items: center; 
                justify-content: space-between;
                .item{
                    overflow: hidden;
                    color: rgba(230, 243, 253, 0.7);
                    font-size: 16rem;
                    margin:3.5vh 0;
                    text-align: center;
                    .title{
                        margin-bottom: 5rem;
                    }
                    .progress{
                        background: url('../../../../assets/img/bottom.png');
                        width:100rem;
                        height: 100rem;
                        background-size: 100% 100%;
                        margin: 15rem 0;
                        display: flex;
                        flex-flow: row wrap;
                        align-items: center;
                        padding: 17rem 0;
                        font-size: 16rem;
                        .num{
                            color: #00DEFF;
                            font-size: 22rem;
                            width: 100%;
                            font-family: zcoolqingkehuangyouti;
                            span{
                                font-size: 16rem;
                                font-family: zcoolqingkehuangyouti;
                            }
                        }
                        .state{
                            text-align: center;
                            width: 100%;
                        }
                    }
                }
            }
            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }
    }
</style>